import React from 'react';
import cn from 'classnames';
import Icon from '../../../../../../../../../components/common/icon';
import { bbCodeToHtml } from '../../../../../../../../../utils/formUtils';
import { Visibility } from '../../../../../../../../../types/common-types';
import './style.scss';

export enum ServiceType {
  Radio = 'radio',
  Check = 'check',
}

interface ValueProps {
  id: string;
  value: string[];
  error: boolean;
}

interface Option {
  value: string;
  title: string;
  visibility?: Visibility;
  type: ServiceType;
}
interface Props {
  id: string;
  value?: string[];
  visibility?: Visibility;
  submitOnChange?: boolean;
  options: Option[];
  onSubmit: (id: string) => void;
  onChange: (value: ValueProps, callback?: () => void) => void;
}

const Service: React.FC<Props> = ({
  id,
  visibility,
  options,
  submitOnChange = false,
  value = [] as string[],
  onChange,
  onSubmit,
}) => {
  const handleOnClick = (service: Option) => {
    const { value: key, type } = service;
    let newValue = value.slice();
    const findIndex = newValue.findIndex(i => i === key);
    if (findIndex === -1) {
      if (type === ServiceType.Radio) {
        newValue = value.filter(
          val =>
            !options
              .filter(opt => opt.type === ServiceType.Radio)
              .map(opt => opt.value)
              .includes(val)
        );
      }
      newValue.push(key);
    } else if (type === ServiceType.Check) {
      newValue.splice(findIndex, 1);
    }

    onChange({ id, value: newValue, error: false }, () => {
      if (submitOnChange) onSubmit(id);
    });
  };
  const isActive = (service: Option) => {
    return value.includes(service.value);
  };
  const renderItems = (type: ServiceType) =>
    options
      .filter(opt => type === opt.type && opt.visibility !== Visibility.Hidden)
      .map(service => (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        <div
          key={service.value}
          data-cy="service"
          role="button"
          tabIndex={visibility === Visibility.Visible ? 0 : -1}
          styleName={cn('service__item', {
            active: isActive(service),
          })}
          onClick={() => handleOnClick(service)}
          onKeyPress={() => {
            handleOnClick(service);
          }}
        >
          {service.type === ServiceType.Check ? (
            <Icon styleName="service__item__icon" value="bullet" />
          ) : null}
          <div // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: bbCodeToHtml(service.title),
            }}
          />
        </div>
      ));

  return (
    <div
      id={id}
      data-cy="service"
      styleName={cn('service', {
        hidden: visibility === Visibility.Hidden,
      })}
    >
      <div styleName="service__box">{renderItems(ServiceType.Check)}</div>
      <div styleName={cn('service__box', { radio: true })}>
        {renderItems(ServiceType.Radio)}
      </div>
    </div>
  );
};

export default Service;
